module.exports = __webpack_public_path__ + "static/RootSans-10BoldItalic-41a5157f4fb575fbdcaa9c2f85c284ab.woff2";